import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import { ROUTES_MAP, RoutesMapValue } from '~/constants/routes';
import { LogoColor } from '~/types-and-enums/logoTypes';
import { ColorModeEnum } from '~/utils/generalUtils';
import { spacing } from '~/utils/tailwindUtils';
import Flex from '../../customComponents/flex/Flex';
import { Icon, IconName } from '../Icon';

type LogoProps = {
  logoColor: LogoColor;
  size?: 'small' | 'big';
  className?: string;
  href?: RoutesMapValue<typeof ROUTES_MAP>;
};

/**
 * A reusable Logo component that renders a link to the home page with an Icon.
 * The Icon's size and color can be customized.
 *
 * @param {LogoColor} logoColor - The color of the logo.
 * @param {('small' | 'big')} [size='big'] - The size of the logo.
 * @param {string} [className] - Additional CSS class names for the Flex Wrapper component.
 * @return {JSX.Element} The Logo component.
 */
const Logo = ({ logoColor, size = 'big', className, href = ROUTES_MAP.home }: LogoProps) => {
  return (
    <Flex className={twMerge('items-center justify-center', className)} data-testid="logo">
      <Link
        href={href}
        className="cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
      >
        <Icon
          color={logoColor}
          name={size === 'big' ? IconName.AndercoreLogoBig : IconName.AndercoreLogoSmall}
          width={size === 'big' ? spacing[40] : spacing[5]}
          height={size === 'big' ? spacing[6] : spacing[6]}
          colorMode={ColorModeEnum.Fill}
        />
      </Link>
    </Flex>
  );
};

export default Logo;
